<template>
  <el-drawer
    v-model="drawerVisible"
    title="AI助手"
    class="aiassistant-drawer"
    :before-close="handleBeforeClose"
    :close-on-click-modal="true"
  >
    <div class="aiassistant" ref="assistantRef" v-loading="loading" @mousedown="handleMouseDown">
      <div v-for="(item, index) in historyList" :key="index" :class="{'aiassistant-item': true, 'aiassistant-user-item': item.role === 'user'}">
        <img v-if="item.role !== historyList[index - 1]?.role" :src="item.role === 'assistant' ? AIImg : UserImg" width="40" height="40" />
        <div v-else style="width: 40px" />
        <div class="assistant-msg-wrapper">
          <div class="aiassistant-item-msg" v-if="!item.plan?.length && (item.content || item.loading || item.isRecording)">
            <div v-if="item.content" v-html="highContent(item.content)" />
            <!-- <template v-if="item.isRecording">
              <div @click="handlePlay(item, index)" class="aiassistant-item-recording">
                <span>{{ formatDuration(item.time) }}</span>
                <span :class="{'recording-play': item.play}">
                  <el-icon :size="18"><svg-icon name="writing/volum" /></el-icon>
                </span>
              </div>
            </template> -->
            <el-icon class="is-loading" :size="22" style="display: flex" v-if="item.loading"><Loading /></el-icon>
          </div>
          <div v-if="item.plan?.length" class="aiassistant-item-msg-plan">
            <span>你可以选择其中任意一个方案</span>
            <div class="aiassistant-plan">
              <el-tabs>
                <el-tab-pane v-for="(plan, planIndex) in item.plan" :key="planIndex" :label="planTitle[planIndex]">
                  <mark class="mark">{{ plan.thought }}</mark>
                  <el-divider border-style="dashed" />
                  {{ plan.content }}
                  <el-button type="primary" @click="handlePlan(plan)">立即使用</el-button>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
          <div v-if="item.suggest?.length" class="assistant-suggest">
            <span>你可以试试这样问我</span>
            <div
              v-for="(suggest, index) in item.suggest"
              class="aiassistant-item-msg"
              :key="index"
              @click="handleSend(suggest)"
            >
              <el-icon :size="18"><svg-icon :name="`writing/comment${(index % item.suggest.length) + 1}`" /></el-icon>
              {{ suggest }}
              <el-icon :size="18"><Right /></el-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="input-box">
      <el-tooltip content="开启新对话" placement="bottom" effect="light">
        <el-button @click="handleNew" class="newStart">
          <el-icon :size="24"><svg-icon name="writing/add" /></el-icon>
        </el-button>
      </el-tooltip>
      <el-tooltip :content="isRecording ? '停止录入' : '语音录入'" placement="bottom" effect="light">
        <el-button @click="handleRecording" class="recordingStart">
          <el-icon :size="24"><svg-icon :name="isRecording ? 'writing/stop' : 'vector'" /></el-icon>
        </el-button>
      </el-tooltip>
      <el-input
        ref="inputRef"
        v-model="inputValue"
        rows="1"
        type="textarea"
        size="large"
        placeholder="发消息"
        :clearable="!isRecording"
      />
      <!-- @keydown.enter="handleSend()" -->
      <!-- 正在聊天中展示停止按钮 -->
      <el-button type="primary" @click="handleStop" class="sendBtn" v-if="abortController">
        <el-icon :size="30"><svg-icon name="writing/stop" /></el-icon>
      </el-button>
      <!-- 正常展示发送按钮 -->
      <el-button type="primary" @click="handleSend()" class="sendBtn" :disabled="isRecording" v-else>
        <el-icon :size="30"><svg-icon name="writing/send" /></el-icon>
      </el-button>
    </div>
    <audio id="ai-audio-player" style="display: none;"></audio>
  </el-drawer>
</template>

<script setup>
import { watch, ref, reactive, onMounted, nextTick, computed, onUnmounted } from 'vue'
import { Right, Loading } from '@element-plus/icons-vue'
import { useUserStore } from '@/store/modules/user';
import AIImg from '@/assets/images/ai.png'
import UserImg from '@/assets/images/user.png'
import { ElMessage } from 'element-plus'

const props = defineProps({
  field: {
    type: String,
    default: ''
  },
  formData: {
    type: Object,
    default: () => ({})
  }
})

const planTitle = ['方案一', '方案二', '方案三']

const userStore = useUserStore()
const emit = defineEmits(['select', 'update'])

const assistantRef = ref()
const drawerVisible = ref(false)
const inputRef = ref()
const inputValue = ref()
// 所有的历史纪录
const allFieldHistory = ref({})
// 当前聊天的记录
const historyList = ref([])
const loading = ref(props.modelValue)
const abortController = ref()
const autoScroll = ref(false)
const isRecording = ref(false)
const currentSentence = ref('')
let recognizer = null
// const abortControllerIndex = ref()

const userAvatar = computed(() => {
  const avatar = userStore.userInfo?.avatar
  const VUE_APP_TDS_SERVER = process.env.VUE_APP_TDS_SERVER;
  return avatar ?  `${VUE_APP_TDS_SERVER}${avatar}` : UserImg
})

const originText = computed(() => {
  return props.formData?.[props.field]
})

const type = computed(() => {
  return props.field === 'technical' ? 'solution' : props.field
})

const highContent = (str) => {
  const replaceReg = /修改思路：.*[\r\n]*/g;
  const match = str.match(replaceReg) || [];
  let result = str;
  match.forEach(item => {
    result = result.replace(item, `<mark class="mark">${item}</mark>`)
  })
  return result;
}

const initAudioRecording = async () => {
  try {
    const params = {
      secretid: process.env.VUE_APP_TENCENT_SECRET_ID,
      secretkey: process.env.VUE_APP_TENCENT_SECRET_KEY,
      appid: Number(process.env.VUE_APP_TENCENT_APPID),
      engine_model_type: '16k_zh',
      voice_format: 1,
      needvad: 1,
      filter_dirty: 0,
      filter_modal: 0,
      filter_punc: 0,
      convert_num_mode: 1,
      word_info: 0
    }

    recognizer = new WebAudioSpeechRecognizer(params, true)

    recognizer.OnRecognitionStart = () => {
      isRecording.value = true
    }

    recognizer.OnSentenceBegin = (res) => {
      if (res.result?.voice_text_str) {
        currentSentence.value = res.result.voice_text_str
        inputValue.value += currentSentence.value
      }
    }

    recognizer.OnRecognitionResultChange = (res) => {
      if (res.result?.voice_text_str) {
        if (currentSentence.value) {
          inputValue.value = inputValue.value.slice(0, -currentSentence.value.length)
        }
        currentSentence.value = res.result.voice_text_str
        inputValue.value += currentSentence.value
      }
    }

    recognizer.OnSentenceEnd = (res) => {
      if (res.result?.voice_text_str) {
        if (currentSentence.value) {
          inputValue.value = inputValue.value.slice(0, -currentSentence.value.length)
        }
        currentSentence.value = res.result.voice_text_str
        inputValue.value += currentSentence.value
        currentSentence.value = ''
      }
    }

    recognizer.OnRecognitionComplete = () => {
      stopRecording()
    }

    recognizer.OnError = (error) => {
      console.error('识别错误:', error)
      stopRecording()
    }

    recognizer.start()

  } catch (error) {
    console.error('录音初始化失败:', error)
    stopRecording()
  }
}

const startRecording = async () => {
  currentSentence.value = ''
  inputValue.value = ''
  await initAudioRecording()
}


const stopRecording = () => {
  if (recognizer) {
    // const audioBlob = recognizer.saveAudioData();
    // if (audioBlob) {
    //   const file = new File([audioBlob], '录音', { type: 'audio/wav' });
    // }

    recognizer.stop();
    recognizer = null;
  }
  isRecording.value = false;
}

// 初始化消息
const handleInit = async () => {
  if (originText.value) {
    loading.value = true

    const field = props.field
    const content = originText.value
    const response = await fetch( '/api/assistant/init', {
      method: 'POST',
      body: JSON.stringify({ type: type.value, content })
    })
    const result = await response.json()

    loading.value = false
    if (result && field === props.field) {
      // 欢迎语
      if (result?.greeting) {
        historyList.value.push({
          role: 'assistant',
          content: result?.greeting,
          init: true,
        })
      }
      historyList.value.push({
        role: 'assistant',
        content: `以下为原文内容：\n${content}`,
        init: true,
      })
      if (result?.suggestions?.length) {
        historyList.value.push({
          role: 'assistant',
          suggest: result?.suggestions,
          init: true,
        })
      }
      nextTick(() => {
        emit('update')
      })
    } else if (field) {
      // 欢迎语
      if (result?.greeting) {
        allFieldHistory.value[field].push({
          role: 'assistant',
          content: result?.greeting,
          init: true,
        })
      }
      allFieldHistory.value[field].push({
        role: 'assistant',
        content: `以下为原文内容：\n${content}`,
        init: true,
      })
      if (result?.suggestions?.length) {
        allFieldHistory.value[field].push({
          role: 'assistant',
          suggest: result?.suggestions,
          init: true,
        })
      }
    }
  }
}

// 生成方案和思路
const handlePlanCard = async (text, chatIndex) => {
  try {
    const response = await fetch('/api/assistant/plan-card', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ text }),
    })

    if (!response.ok) {
      ElMessage.error('获取方案失败')
      return
    }

    const result = await response.json()

    historyList.value[chatIndex].plan = result
    nextTick(() => {
      emit('update')
      handleScrollBottom()
    })
  } catch (error) {

  }
}

// 发送
const handleSend = async (text) => {
  const userInput = text || inputValue.value?.trim()
  if (!userInput) {
    ElMessage.warning('不能发送空白信息')
    return
  }
  const messages = historyList.value.filter(v => !v.loading && !v.init)

  historyList.value.push({ role: 'user', content: userInput, stream: true })
  historyList.value.push({ role: 'assistant', content: '', loading: true, stream: true })

  if (!text) {
    inputValue.value = undefined
  }

  abortController.value = new AbortController()
  autoScroll.value = true
  try {
    const response = await fetch('/api/assistant/chat', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'text/event-stream'
      },
      body: JSON.stringify({
        type: type.value,
        originalText: originText.value,
        userInput,
        messages
      }),
      signal: abortController.value.signal
    })

    if (!response.ok) {
      throw new Error('对话失败')
    }

    const chatIndex = historyList.value.length - 1
    // abortControllerIndex.value = chatIndex

    const reader = response.body.getReader()
    let chatStr = '';
    while (true) {
      const { done, value } = await reader.read()
      if (done) {
        abortController.value = null
        historyList.value[chatIndex - 1].stream = false
        historyList.value[chatIndex].stream = false
        handlePlanCard(chatStr, chatIndex)
        break
      }

      // 将 Uint8Array 转换为文本
      const chunk = new TextDecoder().decode(value)
      const lines = chunk.split('\n')

      for (const line of lines) {
        if (line.startsWith('data: ')) {
          const jsonStr = line.slice(5).trim()
          if (jsonStr === '[DONE]') {
            continue
          }
          try {
            const data = JSON.parse(jsonStr)
            if (data.result) {
              // 每次只添加新的内容
              chatStr += data.result
              historyList.value[chatIndex].content = chatStr
              historyList.value[chatIndex].loading = false
            }
          } catch (e) {
            console.warn('解析 SSE 数据失败:', e)
          }
        }
      }
    }
  } catch (error) {

  }
}

const handleRecording = () => {
  if (abortController.value) {
    handleStop()
  }
  if (isRecording.value) {
    stopRecording()
  } else {
    startRecording()
  }
}

const handleScrollBottom = () => {
  if (!autoScroll.value) return
  assistantRef.value.scrollTo({ top: assistantRef.value.scrollHeight, behavior: 'smooth' })
}

const handlePlan = async (plan) => {
  if (plan.content) {
    drawerVisible.value = false
    emit('select', { content: plan.content, field: props.field })
  }
}

const handleStop = () => {
  if (abortController.value) {
    abortController.value.abort()
    abortController.value = null
  }
  // if (abortControllerIndex.value || abortControllerIndex.value === 0) {
  //   historyList.value[abortControllerIndex.value].showPlan = true
  //   abortControllerIndex.value = null
  // }
}

const handlePlay = (file, index) => {
  const audio = document.getElementById('ai-audio-player');
  if (audio && !audio.paused) {
    audio.pause()
    delete historyList.value[index].play
    return
  }
  if (file.file) {
    const url = URL.createObjectURL(file.file)
    audio.src = url
    audio.play()
    historyList.value[index].play = true

    // 播放结束时清理
    audio.onended = () => {
      delete historyList.value[index].play
      URL.revokeObjectURL(url)
    };
  }
}

const handleBeforeClose = (done) => {
  if (abortController.value) {
    handleStop()
  }
  if (isRecording.value) {
    stopRecording()
  }
  inputValue.value = ""
  done()
}

const handleUserSchool = (e) => {
  if (e.wheelDelta > 0) {
    // 向上滚动
    autoScroll.value = false
  } else {
    // 向下滚动
    const top = 80
    autoScroll.value = assistantRef.value.scrollTop + assistantRef.value.clientHeight + top >= assistantRef.value.scrollHeight
  }
}

const handleNew = () => {
  if (abortController.value) {
    handleStop()
  }
  if (isRecording.value) {
    stopRecording()
  }
  historyList.value = []
  handleInit()
}

const handleMouseDown = (e) => {
  if (e.offsetX + 8 >= 550) {
    autoScroll.value = false
  }
}

function formatDuration(seconds) {
  if (!seconds) return ''
  seconds = Math.floor(seconds);
  var minutes = Math.floor(seconds / 60);
  seconds = seconds % 60;

  if (minutes < 10) {
    minutes = '0' + minutes;
  }
  if (seconds < 10) {
    seconds = '0' + seconds;
  }
  return minutes + ':' + seconds;
}

const adjustTextareaHeight = (val) => {
  nextTick(() => {
    if (inputRef.value) {
      inputRef.value.ref.style.height = 'auto'

      const scrollHeight = inputRef.value.ref.scrollHeight
      inputRef.value.ref.style.height = val ? scrollHeight + 'px' : '0px'
      assistantRef.value.style.height = `calc(100vh - ${scrollHeight + 100}px)`
    }
  })
}

// 监听 modelValue 变化
watch(() => props.field, (newVal) => {
  const boolVal = Boolean(newVal)

  if (drawerVisible.value !== boolVal) {
    drawerVisible.value = boolVal
    if (boolVal) {
      historyList.value = allFieldHistory.value[newVal] || []
      // inputValue.value = ''
      autoScroll.value = false
      if (!historyList.value.length) {
        handleInit()
      }
    }
  }
  nextTick(() => {
    assistantRef.value?.scrollTo?.({ top: 0 })
    assistantRef.value.removeEventListener('wheel', handleUserSchool)
    assistantRef.value.addEventListener('wheel', handleUserSchool)
  })
})

// 监听 drawerVisible 变化
watch(() => drawerVisible.value, (newVal) => {
  if (!newVal) {
    emit('update:modelValue', false)
  }
})

watch(() => historyList.value, (newVal) => {
  allFieldHistory.value[props.field] = JSON.parse(JSON.stringify(newVal?.filter(v => !v.stream)))
}, { deep: true })

watch(() => [historyList.value[historyList.value.length - 1]?.content, historyList.value.length], (newVal) => {
  nextTick(() => {
    handleScrollBottom()
  })
})

watch(() => inputValue.value, (newVal) => {
  adjustTextareaHeight(newVal)
})

onUnmounted(() => {
  assistantRef.value?.removeEventListener('wheel', handleUserSchool)
})

onMounted(() => {
  handleInit()
})

defineExpose({
  allFieldHistory,
  // inputValue, // 暴露 inputValue 供父组件访问
  // 设置输入值的方法
  setInputValue: (val) => {
    inputValue.value = val
  },
  // setAllFieldHistory: () => {}
  setAllFieldHistory: (val) => allFieldHistory.value = JSON.parse(JSON.stringify(val || {}))
})

</script>

<style lang="scss">
.aiassistant-drawer {
  width: 550px !important;
  border-radius: 8px 0px 0px 8px;
  .el-drawer__header {
    height: 58px;
    padding: 0 16px;
    margin: 0;
    .el-drawer__title {
      font-weight: 600;
      font-size: 18px;
      color: #000000;
    }
  }
  .el-drawer__body {
    padding: 0;
    background: #F9F9F9;
  }
}
</style>
<style lang="scss" scoped>
.aiassistant {
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: calc(100vh - 150px);
  padding: 10px 16px;
  overflow: auto;
  .aiassistant-item {
    display: flex;
    gap: 10px;
    max-width: 80%;
    &.aiassistant-user-item {
      flex-direction: row-reverse;
      padding-left: 20%;
      > img {
        border-radius: 50%;
      }
    }
    .assistant-msg-wrapper {
      // flex: 1;
      max-width: calc(100% - 50px);
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
    .aiassistant-item-msg {
      padding: 16px;
      white-space: pre-wrap;
      line-height: 22px;
      background: #fff;
      border-radius: 8px;
      border: 1px solid #E1E1E1;
      :deep(.mark) {
        background: rgba(255,0,0,0.15);
      }
    }
    .assistant-suggest {
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin-top: 10px;
      > span {
        color: #585858;
      }
      .aiassistant-item-msg {
        display: flex;
        align-items: center;
        gap: 8px;
        width: fit-content;
        max-width: 100%;
        box-sizing: border-box;
        cursor: pointer;
      }
    }
    .aiassistant-plan {
      margin-top: 10px;
      padding: 10px 16px;
      background: #fff;
      border-radius: 8px;
      border: 1px solid #E1E1E1;
      :deep(.el-tabs) {
        .el-tabs__nav {
          width: 100%;
          .el-tabs__item {
            flex: 1;
            color: #555;
            &.is-active {
              color: #222;
              font-weight: 600;
            }
          }
        }
        .el-tab-pane {
          display: flex;
          flex-direction: column;
          gap: 16px;
          padding-bottom: 10px;
        }
        .el-divider--horizontal {
          margin: 0;
        }
        .mark {
          background: rgba(255,0,0,0.15);
        }
      }
    }
    .aiassistant-item-msg-plan {
      margin-top: 10px;
      display: flex;
      flex-direction: column;
      gap: 10px;
      > span {
        color: #585858;
      }
    }
    .aiassistant-item-recording {
      min-width: 70px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      line-height: 18px;
      .recording-play {
        position: relative;
        &:before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          width: 12px;
          height: 18px;
          background: #fff;
          z-index: 10;
          animation: play 1s infinite;
          @keyframes play {
            0% { width: 12px }
            100% { width: 0 }
          }
        }
      }
    }
  }
}
.input-box {
  position: relative;
  margin: 20px 16px;
  :deep(.el-textarea) {
    background: #FFFFFF;
    borde-color: #E1E1E1;
    border-radius: 8px 8px 8px 8px;
    .el-textarea__inner {
      padding: 14px 46px 14px 70px;
      resize: none;
    }
    .el-input__suffix {
      .el-icon {
        font-size: 18px;
      }
    }
  }
  .recordingStop {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    height: 50px;
    background: #FFFFFF;
    border: 1px solid #E1E1E1;
    border-radius: 8px 8px 8px 8px;
    cursor: pointer;
  }
  .newStart, .recordingStart {
    position: absolute;
    top: 50%;
    z-index: 10;
    margin: 0;
    padding: 0;
    background: none;
    border: none;
    transform: translateY(-50%);
  }
  .newStart {
    left: 10px;
  }
  .recordingStart {
    left: 40px;
  }
  .sendBtn {
    position: absolute;
    top: 50%;
    right: 10px;
    z-index: 10;
    padding: 0;
    background: none !important;
    border: none !important;
    transform: translateY(-50%);
  }
}
</style>
